import React from "react"
import { Col, Row } from "reactstrap"
import NumberFormat from "../../../../utils/numberFormat"

const ContraVoucherView = ({  invoiceDetails }) => {
  const desimalrange = localStorage.getItem("desimalrange")

  const handleContaAmounts = journalEntryDetails =>
    journalEntryDetails?.reduce(
      (sum, entry) => sum + (parseFloat(entry?.credit_amount) || 0),
      0
    )

  return (
    <>
      <Row className="mt-4">
        <Col lg={12}>
          <h5 className="productDetail edittheamtitle">
            {invoiceDetails?.voucher_id == 1 ||
            invoiceDetails?.voucher_id == 3 ||
            invoiceDetails?.voucher_id == 6 ||
            invoiceDetails?.voucher_id == 8
              ? "Details"
              : invoiceDetails?.voucher_id == 13
              ? "Sales Detail"
              : "Material Details"}
          </h5>
        </Col>
        <Col lg={12}>
          <table className="estimation-table mb-4">
            <thead>
              <tr>
                <th>Type</th>
                <th>Account Head</th>
                <th className="text-end pe-2">Debit (AED)</th>
                <th className="text-end pe-5">Credit (AED)</th>
              </tr>
            </thead>
            <tbody>
              {invoiceDetails?.journal_entry?.journal_entry_details?.map(
                (data, index) => (
                  <React.Fragment key={index}>
                    <tr>
                      <td className="ps-1">
                        {Number(data?.debit_amount) != 0 ? "Dr" : "Cr"}
                      </td>
                      <td className="ps-1">{data?.ledger?.name || "-"}</td>
                      <td className="ps-1 text-end pe-2">
                        {data?.debit_amount
                          ? NumberFormat(
                              Number(data?.debit_amount),
                              desimalrange,
                              desimalrange
                            )
                          : NumberFormat(0, desimalrange, desimalrange)}
                      </td>
                      <td className="ps-1 text-end pe-5">
                        {data?.credit_amount
                          ? NumberFormat(
                              Number(data?.credit_amount),
                              desimalrange,
                              desimalrange
                            )
                          : NumberFormat(0, desimalrange, desimalrange)}
                      </td>
                    </tr>
                    {(data?.voucher_partial_payment?.length || data?.bank_payments?.length) ? (
                      <tr className="td-wt-no-border">
                        <td colSpan="4" className="ps-1">
                          Details
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                    {data?.voucher_partial_payment?.map(
                      (item, paymentIndex) => (
                        <React.Fragment key={paymentIndex}>
                          <tr className="td-wt-no-border">
                            <td colSpan="4" className=" ps-1">
                              {item?.ref_id == 1
                                ? "Advance"
                                : item?.ref_id == 2
                                ? "Against"
                                : "New"}{" "}
                              {item?.code} {item?.amount}{" "}
                              {item?.credit_debit == "debit" ? "Dr" : "Cr"}
                            </td>
                          </tr>
                        </React.Fragment>
                      )
                    )}
                    {data?.bank_payments?.map(
                      (item, paymentIndex) => (
                        <React.Fragment key={paymentIndex}>
                          <tr className="td-wt-no-border">
                            <td colSpan="4" className=" ps-1">
                              {item?.payment_type_value?.value}{" "}
                              {item?.instrument_no} 
                              {/* {NumberFormat(Number(item?.amount || 0), desimalrange || 2, desimalrange || 2)}{" "} */}
                              {/* {item?.credit_debit == "debit" ? "Dr" : "Cr"} */}
                            </td>
                          </tr>
                        </React.Fragment>
                      )
                    )}
                  </React.Fragment>
                )
              )}
            </tbody>
          </table>
        </Col>
        <Row>
          <Col></Col>
          <Col>
            <Row>
              <Col lg="6"></Col>
              <Col lg="3" className="py-2">
                <div className="text-end">Sub Total</div>
              </Col>
              <Col lg="3" className="py-2">
                {NumberFormat(
                  Number(
                    handleContaAmounts(
                      invoiceDetails?.journal_entry?.journal_entry_details || []
                    )
                  ),
                  desimalrange,
                  desimalrange
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Row>
      <Row>
        {invoiceDetails?.narration ? (
          <Col lg={6} md={8} sm={12} className="pb-4">
            <div className="supplier-td-head">Narration</div>
            <div className="supplier-td-body">
              {invoiceDetails ? invoiceDetails?.narration : "-"}
            </div>
          </Col>
        ) : null}
      </Row>
    </>
  )
}

export default ContraVoucherView
